import { render, staticRenderFns } from "./MyOrganizationGuardbook.vue?vue&type=template&id=6f49bb34"
import script from "./MyOrganizationGuardbook.vue?vue&type=script&lang=js"
export * from "./MyOrganizationGuardbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports